import { filter, map, take } from 'rxjs/operators';
import { OnInit, ViewContainerRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import * as user from '../../../auth/actions/user';
import * as pages from '../../actions/pages.actions';
import * as menus from '../../actions/menus.actions';
import * as cart from '../../../cart/actions/cart';
import * as status from '../../../base/actions/status.actions';
import * as product from '../../../catalog/actions/product';
import * as fromBase from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import * as fromCart from '../../../cart/reducers';
import * as fromCatalog from '../../../catalog/reducers';
import { ThemeConfig } from '../../../core/helpers/theme-config';
import { getFromUrlTerm } from '../../../core/helpers/url-ready';
import { CrashService } from '../../../core/services/crash.service';
import * as moment from 'moment';
import { PageRoutingService } from '../../../core/services/page-routing.service';
import chaining from '../../../core/helpers/chaining';
var viewMode = ThemeConfig.viewMode;
var catalogRouteName = ThemeConfig.get('catalog', 'route-name');
var logoUrl = ThemeConfig.get('app', 'logo');
var BaseContainer = /** @class */ (function () {
    function BaseContainer(store, router, translate, container, pageRouting, crash) {
        var _this = this;
        this.store = store;
        this.router = router;
        this.translate = translate;
        this.container = container;
        this.pageRouting = pageRouting;
        this.crash = crash;
        this.user$ = store.pipe(select(fromAuth.getUser));
        this.languages$ = store.pipe(select(fromBase.getSupportedLanguages));
        var browserLang = translate.getBrowserLang();
        // Set user lang or use browser lang
        this.user$.pipe(take(1), map(function (user) { return user && user.preferences && user.preferences.language; })).subscribe(function (lang) {
            translate.use(lang || browserLang);
            moment.locale(lang || browserLang);
        });
        this.languages$.subscribe(function (languages) {
            _this.languages = languages.map(function (langCode) { return ({ code: langCode, name: "lang." + langCode }); });
            // Default fallback lang is browser lang
            if (_this.languages.find(function (lang) { return lang.code === browserLang; }))
                translate.setDefaultLang(browserLang);
            else {
                browserLang = chaining(_this.languages, '[0].code') || 'en';
                translate.setDefaultLang(browserLang);
            }
        });
        this.isLoggedIn$ = store.pipe(select(fromAuth.isLoggedIn));
        this.isCustomerSelected$ = this.store.pipe(select(fromAuth.isCustomerSelected));
        this.isSalesRep$ = this.store.pipe(select(fromAuth.isSalesRep));
        this.isAdmin$ = this.store.pipe(select(fromAuth.isAdmin));
        this.cart$ = store.pipe(select(fromCart.getCartStats));
        this.currency$ = store.pipe(select(fromAuth.getCurrency));
        this.isPagesLoading$ = store.pipe(select(fromBase.isPagesLoading));
        this.catalogPages$ = store.pipe(select(fromBase.getCatalogPages));
        this.menuItems$ = store.pipe(select(fromBase.getTopMenuList));
        //this.crumbs$ = pageRouting.breadCrumbs$
        //this.showCrumbs$ = pageRouting.breadcrumbsStatus$
        this.simplifiedHeader$ = pageRouting.simplifiedHeaderStatus$;
        //this.tenantSettings$ = store.pipe(select(fromBase.getTenantSettings))
        this.searchTerm$ = store.pipe(select(fromCatalog.getSearchTerm), filter(function (term) { return !!term; }), map(getFromUrlTerm));
        this.searchTerm$.subscribe(function (term) { return _this.searchTerm = term; });
        this.navigateUrl$ = router.events.pipe(filter(function (ev) { return ev instanceof NavigationStart; }), map(function (ev) { return ev.url; }));
        this.globalProductsIsLoading$ = this.store.pipe(select(fromCatalog.isGlobalProductsLoading));
        this.store.pipe(select(fromBase.showHeader)).subscribe(function (showHeader) {
            _this.showHeader = showHeader;
        });
        // When app reloads, force getting of new pages and menus
        this.store.dispatch(new pages.Init(true));
        this.store.dispatch(new menus.Init(true));
        this.store.dispatch(new status.SetHeader(true));
    }
    BaseContainer.prototype.ngOnInit = function () {
        this.topMenuStyle$ = this.store.pipe(select(fromBase.getTopMenuStyle));
    };
    Object.defineProperty(BaseContainer.prototype, "logoUrl", {
        get: function () {
            return logoUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseContainer.prototype, "viewMode", {
        get: function () {
            return viewMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseContainer.prototype, "catalogRoute", {
        get: function () {
            return catalogRouteName;
        },
        enumerable: true,
        configurable: true
    });
    BaseContainer.prototype.onSearch = function (term) {
        this.router.navigate([
            'search',
            term
        ]);
    };
    BaseContainer.prototype.selectCustomer = function () {
        this.router.navigateByUrl('/customer-selection');
        this.store.dispatch(new cart.Reset());
        this.store.dispatch(new user.SelectCustomer());
    };
    BaseContainer.prototype.onLangChange = function (code) {
        this.store.dispatch(new user.SetLanguage(code));
    };
    BaseContainer.prototype.itemClick = function () {
        this.store.dispatch(new product.SetProductDefaultSortOrder());
    };
    return BaseContainer;
}());
export { BaseContainer };
